import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "../../firebase";

import { Navigate, Outlet } from "react-router-dom";
import { useEffect, useState } from "react";
import { PropagateLoader } from "react-spinners";
const PrivateRoutes = () => {
  const [user, loading] = useAuthState(auth);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!loading) {
      setIsLoading(false);
    }
  }, [loading]);
  return user ? (
    <Outlet />
  ) : isLoading ? (
    <PropagateLoader color="#006eb7" size={5} className="loadingSpinner" />
  ) : (
    <Navigate to="/login" />
  );
};

export default PrivateRoutes;
